import { useEffect } from "react";

const DEFAULT_TITLE = "PepMuse — Your peptide brand. Supply, vials, website & fulfillment.";
const DEFAULT_DESC =
  "PepMuse builds research peptide brands end to end — wholesale peptide supply, white-label vials, brand identity, custom website, and 3PL fulfillment in one package.";

const setMeta = (selector, value) => {
  const el = document.head.querySelector(selector);
  if (el) {
    const prev = el.getAttribute("content");
    el.setAttribute("content", value);
    return prev;
  }
  return null;
};

export function usePageMeta(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title || DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const prevDesc = setMeta('meta[name="description"]', desc);
    const prevOgT = setMeta('meta[property="og:title"]', title || DEFAULT_TITLE);
    const prevOgD = setMeta('meta[property="og:description"]', desc);
    const prevTwD = setMeta('meta[name="twitter:description"]', desc);
    return () => {
      document.title = prevTitle;
      if (prevDesc) setMeta('meta[name="description"]', prevDesc);
      if (prevOgT) setMeta('meta[property="og:title"]', prevOgT);
      if (prevOgD) setMeta('meta[property="og:description"]', prevOgD);
      if (prevTwD) setMeta('meta[name="twitter:description"]', prevTwD);
    };
  }, [title, description]);
}
